<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{}">
      <BaseButton
        v-if="create"
        @click="openModal"
        :minimalize="minimalize"
        :text="
          minimalize
            ? localStorage.translations.pages['common']['buttons']['dobavit']
            : localStorage.translations.pages['setting-scheme_type']['dialogs-add_edit-buttons'][
                'dobavit-tip-chertezha'
              ]
        "
        default_icon="button-add"
      />
      <EditBtn v-else :openModal="openModal" />
    </template>
    <transition :duration="150">
      <WorkDocsSchemeTypeModalForm
        v-if="dialog"
        @input="dialog = false"
        :id="id"
        :dialog="dialog"
        :closeModal="closeModal"
        :create="create"
      />
    </transition>
  </v-dialog>
</template>

<script>
import EditBtn from 'components/EditBtn'
import WorkDocsSchemeTypeModalForm from 'components/setting/workDocsSchemeType/WorkDocsSchemeTypeModalForm'

export default {
  name: 'WorkDocsSchemeTypeModal',
  components: { WorkDocsSchemeTypeModalForm, EditBtn },
  props: ['id', 'create', 'minimalize'],
  data() {
    return {
      dialog: false,
    }
  },
  watch: {},
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>
